import { FIELD_VIEWERS, normalizeLoadedFormValues } from '@wix/form-fields';
import { deepEqual } from 'fast-equals';
import { useEffect, useMemo, useRef } from 'react';
import { autofillValues } from '../../components/form/autofill';
import { fillEmptyValues } from '../form-values';
// eslint-disable-next-line max-params
export const useFormValues = (form, values, onChange, userData, addressTemplates, enableAutofill)=>{
    const hasAutofilled = useRef(false);
    const normalizedValues = useMemo(()=>{
        let filled = fillEmptyValues(form, values);
        if (enableAutofill && !hasAutofilled.current && userData) {
            hasAutofilled.current = true;
            filled = autofillValues(form, filled, userData);
        }
        return normalizeLoadedFormValues(FIELD_VIEWERS, form, filled, true, addressTemplates);
    }, [
        form,
        values,
        userData,
        addressTemplates,
        enableAutofill
    ]);
    useEffect(()=>{
        const hasAnyValueChanged = !deepEqual(normalizedValues, values);
        if (hasAnyValueChanged) {
            onChange?.(normalizedValues);
        }
    }, [
        values,
        normalizedValues,
        onChange
    ]);
    return normalizedValues;
};

//# sourceMappingURL=use-form-values.js.map